import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import IUrlData from "../../../core/src/server/data/IUrlData";

import GameModel from "../../../core/src/model/GameModel";

export default class UrlParametersParser implements IBaseDataParser<IUrlData>{
    check(data){
        return data?.user; 
    }

    parse(data):IUrlData {
        return {
            playerToken:data.user
        }
    }

}